module.exports = __webpack_public_path__ + "img/8.bd3e4e25.png";